module.exports = __webpack_public_path__ + "static/img/dongle.bb31a0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/dongle.png
// module id = X9HP
// module chunks = 1